import { apiGet } from '@/store/api';
import { useHelperStore } from '@/store/helperStore';

export async function getOwnTowageCompanies() {
  const data = await apiGet('helper/towageCompanies');

  useHelperStore().setTowageCompanies(data);
}
